import '../css/app.css'
import { createApp } from 'vue'
import { createVuetify } from 'vuetify'
import * as components from 'vuetify/components'
import * as directives from 'vuetify/directives'
import 'vuetify/styles'
import { cs } from 'vuetify/locale'
import Axios from 'axios'
import QS from 'qs'

const vuetify = createVuetify({
  components,
  directives,
  locale: {
    locale: document.documentElement.lang || 'cs',
    messages: { cs }
  },
  theme: {
    defaultTheme: 'light'
  }
})

export default function createAppInstance() {
  const app = createApp({
    data() {
      return {
        menuOpened: false,
        dialogLogin: false,
        dialogLoginName: null as string | null,
        dialogLoginLoading: false,
        dialogLoginResult: null as 'sent' | 'unknown' | 'error' | null,
        rankTab: null as number | null,
        scarfTab: null as number | null
      }
    },
    methods: {
      toggleMenu() {
        this.menuOpened = !this.menuOpened
      },
      async sendLoginLink() {
        this.dialogLoginLoading = true
        this.dialogLoginResult = null

        try {
          await Axios.post('/prihlaseni', QS.stringify({
            login: this.dialogLoginName
          }))
          this.dialogLoginResult = 'sent'
        } catch (error) {
          this.dialogLoginResult = Axios.isAxiosError(error) && error.response?.status === 404 ? 'unknown' : 'error'
        } finally {
          this.dialogLoginLoading = false
        }
      }
    }
  })

  app.use(vuetify)

  return app
}
